import * as React from "react";
import { Context } from "./_context";
export const DineInIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15.5 22H9v-2h6.5v2Zm2.776-20.369-5.174 6.37h.612l7.756-4.848 1.06 1.695L17.486 8H22l.102.005A1 1 0 0 1 23 9c0 5.62-5.027 10-11 10S1 14.62 1 9l.005-.102A1 1 0 0 1 2 8h8.523l6.2-7.63 1.553 1.261Zm-15.203 8.37c.55 3.873 4.251 7 8.927 7 4.676 0 8.376-3.127 8.927-7H3.073Z", fill: "currentColor" }));
  return iconset[size];
};
DineInIcon.iconId = "8XkIpW";
